import React, {Component} from 'react';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import styles from './styles.css';

export default class LLDealerHome extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Lado a Lado Distribuidor' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='ll'
                        userType='dealer'
                        links={['trialSigns']}
                    />
                    <div className={styles.message}>
                        <p>Realizá tu pedido</p>
                        <p>
                        Solicitá las bolsas de lado a lado en función de los requerimientos establecidos en las
                        condiciones comerciales. Recordá que esta acción está orientada a productores de más de 200 Has,
                        donde por lo menos, un 70% deben ser prospectos.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/lado-a-lado/dealer/home/index.js